module.exports = __webpack_public_path__ + "static/media/006.eaae6e85.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/totoro/006.gif
// module id = 839
// module chunks = 0